import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import { CSSReset, ThemeProvider, theme } from '@blockstack/ui';
import { createGlobalStyle } from 'styled-components';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

const DefaultTheme = {
    ...theme,
    colors: {
        primary: '#3700ff',
        secondary: 'magenta',
    },
};

const GlobalStyle = createGlobalStyle`
  a {
    //@ts-ignore
    color: ${(props) => props.theme.colors.primary};
  }
`;

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={DefaultTheme}>
            <CSSReset />
            <GlobalStyle />
            <BrowserRouter>
                <Switch>
                    <Route path="/" component={App} />
                </Switch>
            </BrowserRouter>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
